import _ from "lodash";
import "./TreeViewSelection.scss";

export default {
  props: [
    "buttonText",
    "multiple",
    "value",
    "disabled",
    "items",
    "subItemKey",
    "title",
    "buttonColor",
    "buttonBackground",
    "previewItem",
    "appendIcon",
    "selectableParentNode",
    "displayPersonName",
    "allowSelectAll"
  ],
  data: () => ({
    dialog: false,
    allSelected: false,
    openIds: [],
    treeKey: 0
  }),
  computed: {
    cardTitle() {
      return (
        this.title || (this.multiple ? "Elemente wählen" : "Element wählen")
      );
    },
    subItems() {
      return _.flatten(this.items?.map(item => item[this.subItemKey])) || [];
    },
    selectedItems: {
      get() {
        let value = this.value
          ? Array.isArray(this.value)
            ? this.value
            : [this.value]
          : [];
        value = value.filter(item =>
          this.displayPersonName
            ? this.getSubItemName(item)?.length
            : this.getSubItemTitle(item)?.length
        );
        return value;
      },
      set(val) {
        if (!this.multiple && val.length > 1)
          val = val.find(item => !this.selectedItems.includes(item));
        this.$emit("updateValue", val);
      }
    },
    cAllowSelectAll() {
      if (this.allowSelectAll === undefined) {
        return true;
      }
      return this.allowSelectAll;
    }
  },
  methods: {
    selectAll() {
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        if (this.openIds.length) {
          this.openIds.forEach(id => {
            const foundItemGroup = this.items.find(item => item._id === id);
            if (foundItemGroup) {
              foundItemGroup[this.subItemKey].forEach(subItem => {
                if (!this.selectedItems.includes(subItem._id))
                  this.setSelection({ _id: subItem._id });
              });
            }
          });
        }
        this.items.forEach(item => {
          if (!this.selectedItems.includes(item._id))
            this.setSelection({ _id: item._id });
        });
      } else {
        if (this.openIds.length) {
          this.openIds.forEach(id => {
            const foundItemGroup = this.items.find(item => item._id === id);
            if (foundItemGroup) {
              foundItemGroup[this.subItemKey].forEach(subItem => {
                this.removeItem(subItem._id);
              });
            }
          });
        }
        this.items.forEach(item => {
          this.removeItem(item._id);
        });
      }
      this.treeKey++;
    },
    getSubItemTitle(id) {
      const foundSubItem = this.subItems?.find(cat => cat?._id === id)?.title;
      const foundMainItem = this.items?.find(cat => cat?._id === id)?.title;
      if (foundMainItem) return foundMainItem;
      if (foundSubItem) return foundSubItem;
      return "";
    },
    getSubItemName(id) {
      const foundSubItem = this.subItems?.find(cat => cat?._id === id);
      const foundMainItem = this.items?.find(cat => cat?._id === id);
      if (foundMainItem)
        return `${foundMainItem.firstName} ${foundMainItem.lastName}`;
      if (foundSubItem)
        return `${foundSubItem.firstName} ${foundSubItem.lastName}`;
      return "";
    },
    isItemSelected(item) {
      return (
        item?.[this.subItemKey]?.some(item =>
          this.selectedItems?.includes(item._id)
        ) || this.selectedItems?.includes(item._id)
      );
    },
    setSelection(item) {
      if (!item?.[this.subItemKey]) {
        if (this.multiple) {
          if (this.selectedItems?.includes(item._id)) this.removeItem(item._id);
          else this.selectedItems?.push(item._id);
        } else {
          if (this.selectedItems?.includes(item._id)) this.selectedItems = [];
          else this.selectedItems = [item._id];
        }
      }
    },
    removeItem(item) {
      this.selectedItems = this.selectedItems.remove(item);
    }
  }
};
